import { apolloClientCC as apolloClient } from "../../../vue-apollo";
// src/store/modules/tv/storeAddContent.js
import { exQue, exMut } from "@/utils/gql";
import {
  SAVE_CHANNEL_LAYOUT,
  EDIT_CHANNEL_LAYOUT,
  DELETE_FILE_REPOSITORIO,
  REMOVE_FILE_FROM_LIST,
} from "../../../apollo/mutations";
import {
  GET_ONE_CANAL,
  GET_LAYOUTS_ACTIONS,
  GET_LAYOUTS_THEMES,
  GET_LAYOUTS_COLORS,
  GET_PAGINAS_FILES_REPOSITORIO,
  GET_TOTAL_FILES_REPOSITORIO,
  GET_ALL_WIDGETS,
  GET_NOTICIAS_OPCIONES,
  GENERATE_UPLOAD_URL,
} from "../../../apollo/queries";
import { SAVE_FILE_REPO } from "../../../apollo/subscriptions";
import moment from "moment";
import { isImage } from "../../../utils/formats.js";
import { VideoAdapter } from "../../../models/VideoAdapter";
import {
  DEFAULT_LOGO_URL,
  N_LAYOUT_BANNERS,
  N_LAYOUT_WIDGETS,
} from "@/utils/constants";
import { setCssColors } from "@/utils/color";

function filteredRepoItems(items, pagination, page) {
  const pageData = pagination?.[page];
  const pageIds = pageData?.ids;

  if (!Array.isArray(pageIds) || pageIds.length === 0) {
    return [];
  }

  return items.filter((item) => pageIds.includes(item.id_archivo)).reverse();
}

// Convierte un string HH:mm:ss a segundos; retorna null si no es válido
const hmsToSeconds = (hms) => {
  if (typeof hms === "number" && Number.isFinite(hms)) return hms;
  if (!hms || typeof hms !== "string") return null;
  const parts = hms.split(":");
  if (parts.length !== 3) return null;
  const [h, m, s] = parts.map((n) => Number(n));
  if (![h, m, s].every(Number.isFinite)) return null;
  return h * 3600 + m * 60 + s;
};

export default {
  namespaced: true,
  state: {
    selectedMediaLimit: 60,
    layoutActions: [],
    themes: [],
    layoutsColors: {},
    channelLayout: {
      id_canal: "",
      id_layout: "",
      logo: {},
      logoActive: true,
      url_logo: "",
      videos: [],
      tiempo_videos: "00:00:00",
      id_tema: 1,
      banners: [],
      bannersH: [],
      bannersHorizontalAlto: [],
      bannersVerticalAAncho: [],
      bannersVerticalBAncho: [],
      bannersVerticalCAncho: [],
      bannersVerticalAAlto: [],
      bannersVerticalBAlto: [],
      bannersVerticalCAlto: [],
      banners_tres_widgets: [],
      color: "#0072f7",
      color_tipografia: "#ffffff",
      widgets: {},
      apiNews: [],
      broadcastWidget: { id_widget: 0, broadcast: [], tiempo_ejecucion: 4 },
      timePerBanner: 4,
      timePerBannerH: 4,
      timePerBannersHorizontalAlto: 4,
      timePerBannerVerticalAAncho: 4,
      timePerBannerVerticalBAncho: 4,
      timePerBannerVerticalCAncho: 4,
      timePerBannerVerticalAAlto: 4,
      timePerBannerVerticalBAlto: 4,
      timePerBannerVerticalCAlto: 4,
      timePer_banners_tres_widgets: 4,
    },
    baseChannelLayout: {
      id_canal: "",
      id_layout: "",
      logo: {},
      logoActive: true,
      url_logo: "",
      videos: [],
      tiempo_videos: "00:00:00",
      banners: [],
      bannersH: [],
      bannersHorizontalAlto: [],
      bannersVerticalAAncho: [],
      bannersVerticalBAncho: [],
      bannersVerticalCAncho: [],
      bannersVerticalAAlto: [],
      bannersVerticalBAlto: [],
      bannersVerticalCAlto: [],
      banners_tres_widgets: [],
      id_tema: 1,
      color: "#0072f7",
      color_tipografia: "#ffffff",
      widgets: {},
      apiNews: [],
      broadcastWidget: { id_widget: 0, broadcast: [], tiempo_ejecucion: 4 },
      timePerBanner: 4,
      timePerBannerH: 4,
      timePerBannersHorizontalAlto: 4,
      timePerBannerVerticalAAncho: 4,
      timePerBannerVerticalBAncho: 4,
      timePerBannerVerticalCAncho: 4,
      timePerBannerVerticalAAlto: 4,
      timePerBannerVerticalBAlto: 4,
      timePerBannerVerticalCAlto: 4,
      timePer_banners_tres_widgets: 4,
    },
    selectedMediaList: [],
    imagesListTime: 4,
    allRepoVideos: [],
    allRepoVideosExternos: [],
    allRepoBanners: [],
    allRepoBannersH: [],
    allRepoBannersHorizontalAlto: [],
    allRepoBannersVerticalAAncho: [],
    allRepoBannersVerticalBAncho: [],
    allRepoBannersVerticalCAncho: [],
    allRepoBannersVerticalAAlto: [],
    allRepoBannersVerticalBAlto: [],
    allRepoBannersVerticalCAlto: [],
    allRepoBannersTresWidgets: [],
    allRepoImages: [],
    allRepoPowerBI: [],
    allRepoVimeo: [],
    repoVideosPagination: [],
    repoExternoPagination: [],
    repoBannersPagination: [],
    repoBannersHPagination: [],
    repoBannersHorizontalAltoPagination: [],
    repoBannersVerticalAAnchoPagination: [],
    repoBannersVerticalBAnchoPagination: [],
    repoBannersVerticalCAnchoPagination: [],
    repoBannersVerticalAAltoPagination: [],
    repoBannersVerticalBAltoPagination: [],
    repoBannersVerticalCAltoPagination: [],
    repoBanners_tres_widgetsPagination: [],
    repoImagesPagination: [],
    repoPowerBIPagination: [],
    repoVimeoPagination: [],
    logoDeleted: false,
  },

  getters: {
    isLayoutValidForBack(state) {
      // Videos Todos los layouts
      if (state.channelLayout.videos.length < 1) {
        return false;
      }

      // Widgets
      if (
        Object.keys(N_LAYOUT_WIDGETS).includes(
          `${state.channelLayout.id_layout}`,
        ) &&
        Object.keys(state.channelLayout.widgets).length <
          N_LAYOUT_WIDGETS[state.channelLayout.id_layout]
      ) {
        return false;
      }

      // Noticias
      if (
        [2, 3, 13].includes(Number(state.channelLayout.id_layout)) &&
        state.channelLayout.apiNews.length === 0
      ) {
        return false;
      }

      // Banners
      if (
        Object.keys(N_LAYOUT_BANNERS).includes(
          `${state.channelLayout.id_layout}`,
        )
      ) {
        const hasSetedBanners = N_LAYOUT_BANNERS[
          state.channelLayout.id_layout
        ].reduce((acc, banner) => {
          if (acc) return true;
          if (state.channelLayout[banner.name].length === 0) {
            return true;
          }
        }, false);
        if (hasSetedBanners) return false;
      }

      return true;
    },

    repoVideosFiltered: (state) => (page) => {
      return filteredRepoItems(
        state.allRepoVideos,
        state.repoVideosPagination,
        page,
      );
    },
    repoVideosExternoFiltered: (state) => (page) => {
      return filteredRepoItems(
        state.allRepoVideosExternos,
        state.repoExternoPagination,
        page,
      );
    },
    repoBannersFiltered: (state) => (page) => {
      return filteredRepoItems(
        state.allRepoBanners,
        state.repoBannersPagination,
        page,
      );
    },
    repoBannersHFiltered: (state) => (page) => {
      return filteredRepoItems(
        state.allRepoBannersH,
        state.repoBannersHPagination,
        page,
      );
    },
    repoBannersHorizontalAltoFiltered: (state) => (page) => {
      return filteredRepoItems(
        state.allRepoBannersHorizontalAlto,
        state.repoBannersHorizontalAltoPagination,
        page,
      );
    },
    repoImagesFiltered: (state) => (page) => {
      return filteredRepoItems(
        state.allRepoImages,
        state.repoImagesPagination,
        page,
      );
    },
    repoPowerBIFiltered: (state) => (page) => {
      return filteredRepoItems(
        state.allRepoPowerBI,
        state.repoPowerBIPagination,
        page,
      );
    },
    repoVimeoFiltered: (state) => (page) => {
      return filteredRepoItems(
        state.allRepoVimeo,
        state.repoVimeoPagination,
        page,
      );
    },
    repoBannersVerticalAAnchoFiltered: (state) => (page) => {
      return filteredRepoItems(
        state.allRepoBannersVerticalAAncho,
        state.repoBannersVerticalAAnchoPagination,
        page,
      );
    },
    repoBannersVerticalBAnchoFiltered: (state) => (page) => {
      return filteredRepoItems(
        state.allRepoBannersVerticalBAncho,
        state.repoBannersVerticalBAnchoPagination,
        page,
      );
    },
    repoBannersVerticalCAnchoFiltered: (state) => (page) => {
      return filteredRepoItems(
        state.allRepoBannersVerticalCAncho,
        state.repoBannersVerticalCAnchoPagination,
        page,
      );
    },
    repoBannersVerticalAAltoFiltered: (state) => (page) => {
      return filteredRepoItems(
        state.allRepoBannersVerticalAAlto,
        state.repoBannersVerticalAAltoPagination,
        page,
      );
    },
    repoBannersVerticalBAltoFiltered: (state) => (page) => {
      return filteredRepoItems(
        state.allRepoBannersVerticalBAlto,
        state.repoBannersVerticalBAltoPagination,
        page,
      );
    },
    repoBannersVerticalCAltoFiltered: (state) => (page) => {
      return filteredRepoItems(
        state.allRepoBannersVerticalCAlto,
        state.repoBannersVerticalCAltoPagination,
        page,
      );
    },

    repoBanners_tres_widgetsFiltered: (state) => (page) => {
      return filteredRepoItems(
        state.allRepoBannersTresWidgets,
        state.repoBanners_tres_widgetsPagination,
        page,
      );
    },

    paginationDataForRepoVideos(state) {
      return {
        page_count:
          state.repoVideosPagination.length == 0
            ? 1
            : state.repoVideosPagination.length,
      };
    },
    paginationDataForRepoVideosExterno(state) {
      return {
        page_count:
          state.repoExternoPagination.length == 0
            ? 1
            : state.repoExternoPagination.length,
      };
    },
    paginationDataForRepoImages(state) {
      return {
        page_count:
          state.repoImagesPagination.length == 0
            ? 1
            : state.repoImagesPagination.length,
      };
    },
    paginationDataForRepoPowerBI(state) {
      return {
        page_count:
          state.repoPowerBIPagination.length == 0
            ? 1
            : state.repoPowerBIPagination.length,
      };
    },
    paginationDataForRepoVimeo(state) {
      return {
        page_count:
          state.repoVimeoPagination.length == 0
            ? 1
            : state.repoVimeoPagination.length,
      };
    },
  },

  mutations: {
    setLayoutsActions(state, layoutActions) {
      state.layoutActions = layoutActions;
    },
    setThemes(state, themes) {
      state.themes = themes;
    },
    setTheme(state, theme) {
      state.channelLayout.id_tema = theme;
      setCssColors(
        state.channelLayout.color,
        state.channelLayout.color_tipografia,
        state.channelLayout.id_tema,
      );
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setLayoutsColors(state, colors) {
      state.layoutsColors = colors.reduce(
        (acc, color) => ({ ...acc, [color.id_tipo]: color }),
        {},
      );
    },

    setSelectedMediaList(state, media) {
      media.forEach((m) => {
        state.selectedMediaList.push(m);
      });
    },
    removeSelectedMediaList(state, index) {
      state.selectedMediaList.splice(index, 1);
    },
    reorderSelectedMediaList(state, list) {
      state.selectedMediaList = [...list];
    },
    cleanSelectedMediaList(state) {
      state.selectedMediaList = [];
    },
    imagesListTimeUpdateState(state, time) {
      state.imagesListTime = time;
    },
    resetChannelContent(state) {
      localStorage.removeItem("channelLayout");
      state.channelLayout = JSON.parse(JSON.stringify(state.baseChannelLayout));
    },
    setChannelLayoutLogo(state, logo) {
      state.channelLayout.logo = logo;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
      if (logo.base64 !== "") state.logoDeleted = false;
    },
    deleteChannelLayoutLogo(state) {
      state.channelLayout.logo = {
        width: "",
        height: "",
        base64: "",
        src: "",
        format: "",
      };
      state.channelLayout.url_logo = "";
      state.logoDeleted = true;
    },
    setChannelLayoutVideos(state, data_) {
      state.channelLayout.videos = data_.videos.slice();
      state.channelLayout.tiempo_videos = data_.tiempo_total;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutBanners(state, data_) {
      state.channelLayout.banners = data_.banners.slice();
      state.channelLayout.timePerBanner = data_.timePerBanner;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutBannersH(state, data_) {
      state.channelLayout.bannersH = data_.banners.slice();
      state.channelLayout.timePerBannerH = data_.timePerBanner;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutBannersHorizontalAlto(state, data_) {
      state.channelLayout.bannersHorizontalAlto = data_.banners.slice();
      state.channelLayout.timePerBannersHorizontalAlto = data_.timePerBanner;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutBannersVerticalAAncho(state, data_) {
      state.channelLayout.bannersVerticalAAncho = data_.banners.slice();
      state.channelLayout.timePerBannerVerticalAAncho = data_.timePerBanner;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutBannersVerticalBAncho(state, data_) {
      state.channelLayout.bannersVerticalBAncho = data_.banners.slice();
      state.channelLayout.timePerBannerVerticalBAncho = data_.timePerBanner;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutBannersVerticalCAncho(state, data_) {
      state.channelLayout.bannersVerticalCAncho = data_.banners.slice();
      state.channelLayout.timePerBannerVerticalCAncho = data_.timePerBanner;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutBannersVerticalAAlto(state, data_) {
      state.channelLayout.bannersVerticalAAlto = data_.banners.slice();
      state.channelLayout.timePerBannerVerticalAAlto = data_.timePerBanner;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutBannersVerticalBAlto(state, data_) {
      state.channelLayout.bannersVerticalBAlto = data_.banners.slice();
      state.channelLayout.timePerBannerVerticalBAlto = data_.timePerBanner;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutBannersVerticalCAlto(state, data_) {
      state.channelLayout.bannersVerticalCAlto = data_.banners.slice();
      state.channelLayout.timePerBannerVerticalCAlto = data_.timePerBanner;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutBannersTresWidgets(state, data_) {
      state.channelLayout.banners_tres_widgets = data_.banners.slice();
      state.channelLayout.timePer_banners_tres_widgets = data_.timePerBanner;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutColor(state, color) {
      state.channelLayout.color = color;
      setCssColors(
        color,
        state.channelLayout.color_tipografia,
        state.channelLayout.id_tema,
      );
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutFontColor(state, fontColor) {
      state.channelLayout.color_tipografia = fontColor;
      setCssColors(
        state.channelLayout.color,
        fontColor,
        state.channelLayout.id_tema,
      );
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutTema(state, tema) {
      state.channelLayout.id_tema = tema;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutLogoActive(state, logoActive) {
      state.channelLayout.logoActive = logoActive;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutWidgets(state, data_) {
      if (state.channelLayout.widgets[data_.rank]) {
        Object.assign(state.channelLayout.widgets[data_.rank], data_.widget);
      } else {
        state.channelLayout.widgets[data_.rank] = { ...data_.widget };
      }
      state.channelLayout.widgets[data_.rank].tiempo_ejecucion =
        data_.tiempo_ejecucion;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutApiNews(state, { apiNews, id_lista = null }) {
      // Validar que apiNews tenga elementos válidos
      if (!apiNews || !Array.isArray(apiNews) || apiNews.length === 0) {
        return;
      }

      // Filtrar elementos vacíos o inválidos
      const validApiNews = apiNews.filter(
        (api) => api && typeof api === "object",
      );

      if (validApiNews.length === 0) {
        return;
      }

      // push cuando sean múltiples apis:
      validApiNews[0].id_widget =
        state.channelLayout.apiNews[0]?.id_widget ?? "0";

      // Agregar id_lista a cada API news
      let processedApiNews = validApiNews;
      if (id_lista) {
        processedApiNews = validApiNews.map((api) => ({ ...api, id_lista }));
      }

      state.channelLayout.apiNews = processedApiNews;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutBroadcast(state, broadcastWidget) {
      state.channelLayout.broadcastWidget = broadcastWidget;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutId(state, id) {
      state.channelLayout.id_canal = id;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    setChannelLayoutDesign(state, layout) {
      state.channelLayout.id_layout = layout;
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },
    getCanal(state, response) {
      state.channelLayout = JSON.parse(JSON.stringify(state.baseChannelLayout));
      let layoutListRep = response.lista_reproduccion[0];

      const hms_to_sec = (hms) => {
        let a = hms.split(":");
        return +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
      };

      // Metadata
      state.channelLayout.id_canal = response.id_canal;

      state.channelLayout.id_layout = layoutListRep.layout.id_layout;
      state.channelLayout.id_tema = layoutListRep.tema.id_tema;

      if (layoutListRep.url_logo === null) {
        state.channelLayout.url_logo = "";
        state.channelLayout.logoActive = false;
      } else {
        state.channelLayout.url_logo = layoutListRep.url_logo;
      }
      state.channelLayout.color = layoutListRep.color;
      state.channelLayout.color_tipografia = layoutListRep.color_tipografia;
      state.channelLayout.id_lista = layoutListRep.id_lista;
      setCssColors(
        state.channelLayout.color,
        state.channelLayout.color_tipografia,
        state.channelLayout.id_tema,
      );
      // Videos
      state.channelLayout.videos = layoutListRep.videos[0]
        ? layoutListRep.videos
            .sort((a, b) => +a.orden - +b.orden)
            .map((video) => {
              if (video.archivo != null) {
                if (isImage(video.archivo.url_archivo)) {
                  video.archivo.tiempo_video = video.tiempo_ejecucion;
                }
              }
              return VideoAdapter.from_get_canal(video);
            })
        : [];

      state.channelLayout.tiempo_videos = layoutListRep.videos[0]
        ? layoutListRep.videos[0].total_tiempo
        : "00:00:00";

      // Banners
      state.channelLayout.banners = layoutListRep.banners[0]
        ? layoutListRep.banners
            .sort((a, b) => +a.orden - +b.orden)
            .map((banner) => {
              return { id_file: banner.id_file, ...banner.archivo };
            })
        : [];
      state.channelLayout.timePerBanner = layoutListRep.banners[0]
        ? hms_to_sec(layoutListRep.banners[0].tiempo_ejecucion)
        : 4;
      // Banners Horizontales
      state.channelLayout.bannersH = layoutListRep.banners_horizontales[0]
        ? layoutListRep.banners_horizontales
            .sort((a, b) => +a.orden - +b.orden)
            .map((banner) => {
              return { id_file: banner.id_file, ...banner.archivo };
            })
        : [];
      state.channelLayout.timePerBannerH = layoutListRep.banners_horizontales[0]
        ? hms_to_sec(layoutListRep.banners_horizontales[0].tiempo_ejecucion)
        : 4;
      // Banners Horizontales Alto
      state.channelLayout.bannersHorizontalAlto = layoutListRep
        .banners_horizontales_alto[0]
        ? layoutListRep.banners_horizontales_alto
            .sort((a, b) => +a.orden - +b.orden)
            .map((banner) => {
              return { id_file: banner.id_file, ...banner.archivo };
            })
        : [];
      state.channelLayout.timePerBannersHorizontalAlto = layoutListRep
        .banners_horizontales_alto[0]
        ? hms_to_sec(
            layoutListRep.banners_horizontales_alto[0].tiempo_ejecucion,
          )
        : 4;

      // Banners Verticales Ancho
      state.channelLayout.bannersVerticalAAncho = layoutListRep
        .banners_lv_ancho_a[0]
        ? layoutListRep.banners_lv_ancho_a
            .sort((a, b) => +a.orden - +b.orden)
            .map((banner) => {
              return { id_file: banner.id_file, ...banner.archivo };
            })
        : [];
      state.channelLayout.timePerBannerVerticalAAncho = response
        .lista_reproduccion[0].banners_lv_ancho_a[0]
        ? hms_to_sec(layoutListRep.banners_lv_ancho_a[0].tiempo_ejecucion)
        : 4;
      state.channelLayout.bannersVerticalBAncho = layoutListRep
        .banners_lv_ancho_b[0]
        ? layoutListRep.banners_lv_ancho_b
            .sort((a, b) => +a.orden - +b.orden)
            .map((banner) => {
              return { id_file: banner.id_file, ...banner.archivo };
            })
        : [];
      // Banners Verticales BAncho
      state.channelLayout.timePerBannerVerticalBAncho = response
        .lista_reproduccion[0].banners_lv_ancho_b[0]
        ? hms_to_sec(layoutListRep.banners_lv_ancho_b[0].tiempo_ejecucion)
        : 4;

      // Banners Verticales CAncho
      state.channelLayout.bannersVerticalCAncho = layoutListRep
        .banners_lv_ancho_c[0]
        ? layoutListRep.banners_lv_ancho_c
            .sort((a, b) => +a.orden - +b.orden)
            .map((banner) => {
              return { id_file: banner.id_file, ...banner.archivo };
            })
        : [];
      state.channelLayout.timePerBannerVerticalCAncho = response
        .lista_reproduccion[0].banners_lv_ancho_c[0]
        ? hms_to_sec(layoutListRep.banners_lv_ancho_c[0].tiempo_ejecucion)
        : 4;

      // Banners Verticales Alto
      state.channelLayout.bannersVerticalAAlto = layoutListRep
        .banners_lv_alto_a[0]
        ? layoutListRep.banners_lv_alto_a
            .sort((a, b) => +a.orden - +b.orden)
            .map((banner) => {
              return { id_file: banner.id_file, ...banner.archivo };
            })
        : [];

      state.channelLayout.timePerBannerVerticalAAlto = response
        .lista_reproduccion[0].banners_lv_alto_a[0]
        ? hms_to_sec(layoutListRep.banners_lv_alto_a[0].tiempo_ejecucion)
        : 4;
      state.channelLayout.bannersVerticalBAlto = layoutListRep
        .banners_lv_alto_b[0]
        ? layoutListRep.banners_lv_alto_b
            .sort((a, b) => +a.orden - +b.orden)
            .map((banner) => {
              return { id_file: banner.id_file, ...banner.archivo };
            })
        : [];

      state.channelLayout.timePerBannerVerticalBAlto = response
        .lista_reproduccion[0].banners_lv_alto_b[0]
        ? hms_to_sec(layoutListRep.banners_lv_alto_b[0].tiempo_ejecucion)
        : 4;
      state.channelLayout.bannersVerticalCAlto = layoutListRep
        .banners_lv_alto_c[0]
        ? layoutListRep.banners_lv_alto_c
            .sort((a, b) => +a.orden - +b.orden)
            .map((banner) => {
              return { id_file: banner.id_file, ...banner.archivo };
            })
        : [];

      // Banners tres widgets (tipo 15) - manejo seguro cuando el arreglo está vacío o indefinido
      const hasBannersTresWidgets =
        Array.isArray(layoutListRep.banners_tres_widgets) &&
        layoutListRep.banners_tres_widgets.length > 0;
      state.channelLayout.timePer_banners_tres_widgets = hasBannersTresWidgets
        ? hms_to_sec(layoutListRep.banners_tres_widgets[0].tiempo_ejecucion)
        : 4;
      state.channelLayout.banners_tres_widgets = hasBannersTresWidgets
        ? layoutListRep.banners_tres_widgets
            .sort((a, b) => +a.orden - +b.orden)
            .map((banner) => ({ id_file: banner.id_file, ...banner.archivo }))
        : [];

      // Widgets (tratamos widgets de noticias de distinta forma dada su posición en el layout)
      const getOptIndicadores = (api) => {
        if (api && api?.id_api == 2) {
          const array_indicadores = api.indicadores_api.map(
            ({ id_indicador }) => id_indicador,
          );
          const arrayIndicadoresFilter = api.indicadores_api.filter(
            ({ id_tipo_fk }) => id_tipo_fk === 1,
          );
          const id_opcion =
            arrayIndicadoresFilter.length === array_indicadores.length ? 1 : 2;

          return {
            id_opcion,
            array_indicadores,
          };
        }
        return null;
      };

      let frontWidgets = layoutListRep.widgets
        .filter((widget) => !widget.api || (widget.api.id_api !== 4 && widget.api.id_api !== 6))
        .map(
          ({
            id_widget,
            tipo_widget,
            modulo,
            api,
            tiempo_ejecucion,
            reconocimientos,
          }) => {
            const dias_accidente =
              api?.id_api == 3
                ? api.dias_accidente.dias_accidente == null ||
                  api.dias_accidente.dias_accidente == ""
                  ? "1"
                  : api.dias_accidente.dias_accidente
                : "0";

            const ubicaciones_clima =
              api?.id_api == 1
                ? api.clima_api.map((item) => ({
                    ...item,
                    ubicacion: item.direccion,
                  }))
                : [];
            return {
              id_objeto: tipo_widget == "1" ? modulo?.id_modulo : api?.id_api,
              tipo_widget: tipo_widget,

              id_widget: id_widget,
              imagen_widget:
                tipo_widget == "1" ? modulo?.url_imagen : api?.url_imagen,
              nombre_widget:
                tipo_widget == "1" ? modulo?.nombre_modulo : api?.nombre_api,

              tiempo_ejecucion: hms_to_sec(tiempo_ejecucion),
              dias_accidente,
              ubicaciones_clima,
              cuenta_regresiva: api?.id_api == 5 ? api.cuenta_regresiva : [],
              reconocimientos,
              opcion_indicadores: getOptIndicadores(api),
            };
          },
        );
      state.channelLayout.apiNews = layoutListRep.widgets_rrss[0]
        ? layoutListRep.widgets_rrss
        : [];

      const broadcastServerWidget = layoutListRep.widgets
        .find((widget) => widget.api && widget.api.id_api === 6);
      state.channelLayout.broadcastWidget = {
        id_widget: broadcastServerWidget?.id_widget ?? 0,
        broadcast: (layoutListRep.widget_broadcast || []).map((msg) => ({
          ...msg,
          fecha_inicio: msg.fecha_inicio
            ? msg.fecha_inicio.replace(' ', 'T').slice(0, 16)
            : '',
          fecha_fin: msg.fecha_fin
            ? msg.fecha_fin.replace(' ', 'T').slice(0, 16)
            : '',
        })),
        tiempo_ejecucion: broadcastServerWidget
          ? hms_to_sec(broadcastServerWidget.tiempo_ejecucion)
          : 4,
      };

      frontWidgets = frontWidgets.reduce((acc, widget) => {
        if (widget.id_objeto !== undefined) {
          acc.push(widget);
        }
        return acc;
      }, []);

      // enumera en un obj los elementos de frontWidgets: { '0': widget0, '1':  ... }
      state.channelLayout.widgets = { ...frontWidgets };
      // Guardar channelLayout en localStorage
      localStorage.setItem(
        "channelLayout",
        JSON.stringify(state.channelLayout),
      );
    },

    getChannelStateFromLS(state) {
      if (localStorage.getItem("channelLayout")) {
        Object.assign(
          state.channelLayout,
          JSON.parse(localStorage.getItem("channelLayout")),
        );
      }
    },

    setAllRepoFiles(state, { fileObjArr, id_detalle = null }) {
      if (!Array.isArray(fileObjArr) || fileObjArr.length === 0) return;

      if (id_detalle) {
        if (id_detalle === "4") {
          state.allRepoBanners = fileObjArr;
        }
        if (id_detalle === "5") {
          state.allRepoBannersH = fileObjArr;
        }
        if (id_detalle === "14") {
          state.allRepoBannersHorizontalAlto = fileObjArr;
        }
        if (id_detalle === "8") {
          state.allRepoBannersVerticalAAncho = fileObjArr;
        }
        if (id_detalle === "9") {
          state.allRepoBannersVerticalBAncho = fileObjArr;
        }
        if (id_detalle === "10") {
          state.allRepoBannersVerticalCAncho = fileObjArr;
        }
        if (id_detalle === "11") {
          state.allRepoBannersVerticalAAlto = fileObjArr;
        }
        if (id_detalle === "12") {
          state.allRepoBannersVerticalBAlto = fileObjArr;
        }
        if (id_detalle === "13") {
          state.allRepoBannersVerticalCAlto = fileObjArr;
        }
        if (id_detalle === "15") {
          state.allRepoBannersTresWidgets = fileObjArr;
        }
        return;
      }
      const id_tipo = fileObjArr[0]?.detalle_tipoa?.tipo_archivo?.id_tipo;

      if (id_tipo === "1") {
        state.allRepoVideos = fileObjArr;
      }
      if (id_tipo === "4") {
        state.allRepoImages = fileObjArr;
      }
      if (id_tipo === "5") {
        state.allRepoVideosExternos = fileObjArr;
      }
      if (id_tipo === "9") {
        state.allRepoPowerBI = fileObjArr;
      }
      if (id_tipo === "10") {
        state.allRepoVimeo = fileObjArr;
      }
    },

    deleteRepoFile(state, resp) {
      const { deleted, type } = resp;

      if (type === 1 || type === "1") {
        state.allRepoVideos = state.allRepoVideos.filter(
          (video) => video.id_archivo != deleted.id_archivo,
        );
      }
      if (type === 4 || type === "4") {
        state.allRepoBanners = state.allRepoBanners.filter(
          (banner) => banner.id_archivo != deleted.id_archivo,
        );
        state.allRepoBannersH = state.allRepoBannersH.filter(
          (banner) => banner.id_archivo != deleted.id_archivo,
        );
      }
      if (type === 14 || type === "14") {
        state.allRepoBannersHorizontalAlto =
          state.allRepoBannersHorizontalAlto.filter(
            (banner) => banner.id_archivo != deleted.id_archivo,
          );
      }
      if (type === 3 || type === "3") {
        state.allRepoImages = state.allRepoImages.filter(
          (img) => img.id_archivo != deleted.id_archivo,
        );
      }
      if (type === 7 || type === "7") {
        state.allRepoVideosExternos = state.allRepoVideosExternos.filter(
          (video) => video.id_archivo != deleted.id_archivo,
        );
      }
      if (type === 15 || type === "15") {
        state.allRepoBannersTresWidgets =
          state.allRepoBannersTresWidgets.filter(
            (banner) => banner.id_archivo != deleted.id_archivo,
          );
      }
      if (type === 9 || type === "9") {
        state.allRepoPowerBI = state.allRepoPowerBI.filter(
          (item) => item.id_archivo != deleted.id_archivo,
        );
      }
      if (type === 20 || type === "20") {
        state.allRepoVimeo = state.allRepoVimeo.filter(
          (item) => item.id_archivo != deleted.id_archivo,
        );
      }
    },

    /**
     * Setea la paginacion en el state segun el tipo de archivo
     * @param {Object} state - El state del modulo
     * @param {Object} { pagination, payload } - El objeto con la paginacion y el objeto con la informacion de la peticion
     * @param {Array} pagination - El arreglo de paginacion
     * @param {Object} payload - El objeto con la informacion de la peticion
     * @param {Number} payload.tipoArchivo - El tipo de archivo: 1: video, 2: banner, 5: bannerH, 6: imagen
     */
    setPagination(state, { pagination, payload, id_detalle = null }) {
      const safePagination = Array.isArray(pagination) ? pagination : [];

      if (id_detalle) {
        if (id_detalle === "4") {
          state.repoBannersPagination = safePagination;
        } else if (id_detalle === "5") {
          state.repoBannersHPagination = safePagination;
        } else if (id_detalle === "14") {
          state.repoBannersHorizontalAltoPagination = safePagination;
        } else if (id_detalle === "8") {
          state.repoBannersVerticalAAnchoPagination = safePagination;
        } else if (id_detalle === "9") {
          state.repoBannersVerticalBAnchoPagination = safePagination;
        } else if (id_detalle === "10") {
          state.repoBannersVerticalCAnchoPagination = safePagination;
        } else if (id_detalle === "11") {
          state.repoBannersVerticalAAltoPagination = safePagination;
        } else if (id_detalle === "12") {
          state.repoBannersVerticalBAltoPagination = safePagination;
        } else if (id_detalle === "13") {
          state.repoBannersVerticalCAltoPagination = safePagination;
        } else if (id_detalle === "15") {
          state.repoBanners_tres_widgetsPagination = safePagination;
        }

        return;
      }
      if (payload.tipoArchivo === "1") {
        state.repoVideosPagination = safePagination;
      } else if (payload.tipoArchivo === "6") {
        state.repoImagesPagination = safePagination;
      } else if (payload.tipoArchivo === "7") {
        state.repoExternoPagination = safePagination;
      } else if (payload.tipoArchivo === "19") {
        state.repoPowerBIPagination = safePagination;
      } else if (payload.tipoArchivo === "20") {
        state.repoVimeoPagination = safePagination;
      }
    },
  },

  actions: {
    async generateUploadURL(_, { fileName, contentType, bitsize }) {
      const url = await exQue(GENERATE_UPLOAD_URL, {
        fileName,
        contentType,
        bitsize,
      });
      return url;
    },

    setSelectedMediaList({ commit, state }, payload) {
      const normalized = Array.isArray(payload)
        ? { mediaList: payload }
        : payload || { mediaList: [] };
      const { mediaList, allowOverLimit = false } = normalized;
      const items = Array.isArray(mediaList) ? mediaList : [mediaList];

      // helper: obtiene duración en segundos de cada item
      const getItemDurationSeconds = (item) => {
        const byField = hmsToSeconds(item?.tiempo_video);
        if (byField !== null) return byField;

        // Imágenes: usar tiempo configurado en segundos
        const tipo = item?.detalle_tipoa?.tipo_archivo?.id_tipo;
        if (tipo === "4") return Number(state.imagesListTime) || 0;

        // Fallback (Opción A): 60s para videos externos/YouTube u otros sin tiempo
        return 60;
      };

      const limitMinutes = state.selectedMediaLimit || 0;
      if (allowOverLimit || limitMinutes <= 0) {
        commit("setSelectedMediaList", items);
        return {
          ok: true,
          exceeded: false,
          limit: limitMinutes,
          added: items.length,
          skipped: 0,
          allowOverLimit,
        };
      }

      const limitSeconds = limitMinutes * 60;
      const currentSeconds = state.selectedMediaList.reduce(
        (acc, item) => acc + getItemDurationSeconds(item),
        0,
      );

      let remaining = Math.max(limitSeconds - currentSeconds, 0);
      if (remaining <= 0) {
        return {
          ok: false,
          exceeded: true,
          limit: limitMinutes,
          added: 0,
          skipped: items.length,
        };
      }

      const toAdd = [];
      let skipped = 0;
      items.forEach((item) => {
        const dur = getItemDurationSeconds(item);
        if (dur <= remaining) {
          toAdd.push(item);
          remaining -= dur;
        } else {
          skipped += 1;
        }
      });

      if (toAdd.length) {
        commit("setSelectedMediaList", toAdd);
      }

      const exceeded = skipped > 0;
      return {
        ok: !exceeded,
        exceeded,
        limit: limitMinutes,
        added: toAdd.length,
        skipped,
      };
    },
    removeSelectedMediaList({ commit, dispatch }, index) {
      const id_file =
        this.state.tvCorporativaModule.selectedMediaList[index]?.id_file;
      if (id_file) {
        dispatch("removeFileMediaList", {
          id_file,
          type: "video",
        });
      }
      commit("removeSelectedMediaList", index);
    },

    async getLayoutsActions({ commit }) {
      const list = await exQue(GET_LAYOUTS_ACTIONS, {}, false);
      commit("setLayoutsActions", [...list]);
    },

    async setTheme({ commit }, theme) {
      commit("setTheme", theme);
    },
    async getThemes({ commit }) {
      const themes = await exQue(GET_LAYOUTS_THEMES, {}, false);
      commit("setThemes", themes);
    },

    async getLayoutsColors({ commit }) {
      const colors = await exQue(GET_LAYOUTS_COLORS, {}, false);
      commit("setLayoutsColors", colors);
    },

    async removeFileMediaList({ state }, { id_file, type }) {
      let res = null;
      try {
        let { id_lista, id_canal } = state.channelLayout;

        // Verificar que id_lista e id_canal existan
        if (!id_lista || !id_canal) {
          console.error("Error: id_lista o id_canal no están definidos");
          return null;
        }

        // Crear el payload con las variables correctas según la documentación GraphQL
        const payload = {
          id_lista: parseInt(id_lista),
          id_canal: parseInt(id_canal),
          videos: type === "video" ? parseInt(id_file) : null,
          banners: type === "banners" ? parseInt(id_file) : null,
          banners_horizontales:
            type === "banners_horizontales" ? parseInt(id_file) : null,
          // Nuevos parámetros para los distintos tipos de banners
          banners_lv_alto_a:
            type === "banners_vertical_a_alto" ? parseInt(id_file) : null,
          banners_lv_alto_b:
            type === "banners_vertical_b_alto" ? parseInt(id_file) : null,
          banners_lv_alto_c:
            type === "banners_vertical_c_alto" ? parseInt(id_file) : null,
          banners_lv_ancho_a:
            type === "banners_vertical_a_ancho" ? parseInt(id_file) : null,
          banners_lv_ancho_b:
            type === "banners_vertical_b_ancho" ? parseInt(id_file) : null,
          banners_lv_ancho_c:
            type === "banners_vertical_c_ancho" ? parseInt(id_file) : null,
          banners_horizontales_alto:
            type === "banners_horizontal_alto" ? parseInt(id_file) : null, //14
          banners_tres_widgets:
            type === "banners_tres_widgets" ? parseInt(id_file) : null, //15
        };
        res = await exMut(
          REMOVE_FILE_FROM_LIST,
          payload,
          "Archivo eliminado correctamente",
          "Error al eliminar el archivo",
        );

        return res.deleted;
      } catch (error) {
        console.error("Error en removeFileMediaList:", error);
      }
      return res;
    },
    cleanSelectedMediaList({ commit }) {
      commit("cleanSelectedMediaList");
    },
    imagesListTimeUpdate({ commit }, time) {
      commit("imagesListTimeUpdateState", time);
    },
    getChannelStateFromLS({ commit }) {
      commit("getChannelStateFromLS");
    },
    resetChannelContent({ commit }) {
      commit("resetChannelContent");
    },
    setChannelLayoutLogo({ commit }, logo) {
      commit("setChannelLayoutLogo", logo);
    },
    deleteChannelLayoutLogo({ commit }) {
      commit("deleteChannelLayoutLogo");
    },
    setChannelLayoutVideos({ commit }, data_) {
      commit("setChannelLayoutVideos", data_);
    },
    setChannelLayoutBanners({ commit }, data_) {
      // Check the banner type by ID rather than using a boolean flag
      switch (data_.bannerTypeId) {
        case "5": // Banner Horizontal
          commit("setChannelLayoutBannersH", data_);
          break;
        case "14": // Banner Regular
          commit("setChannelLayoutBannersHorizontalAlto", data_);
          break;
        case "8": // Banner Vertical A - Ancho
          commit("setChannelLayoutBannersVerticalAAncho", data_);
          break;
        case "9": // Banner Vertical B - Ancho
          commit("setChannelLayoutBannersVerticalBAncho", data_);
          break;
        case "10": // Banner Vertical C - Ancho
          commit("setChannelLayoutBannersVerticalCAncho", data_);
          break;
        case "11": // Banner Vertical A - Alto
          commit("setChannelLayoutBannersVerticalAAlto", data_);
          break;
        case "12": // Banner Vertical B - Alto
          commit("setChannelLayoutBannersVerticalBAlto", data_);
          break;
        case "13": // Banner Vertical C - Alto
          commit("setChannelLayoutBannersVerticalCAlto", data_);
          break;
        case "15":
          commit("setChannelLayoutBannersTresWidgets", data_);
          break;
        case "2": // Banner Vertical (original)
        default: // Default to regular banner (type 4)
          commit("setChannelLayoutBanners", data_);
          break;
      }
    },
    setChannelLayoutColor({ commit }, color) {
      commit("setChannelLayoutColor", color);
    },
    setChannelLayoutFontColor({ commit }, fontColor) {
      commit("setChannelLayoutFontColor", fontColor);
    },
    setChannelLayoutWidgets({ commit }, data_) {
      commit("setChannelLayoutWidgets", data_);
    },
    setChannelLayoutApiNews({ commit }, { apiNews, id_lista = null }) {
      commit("setChannelLayoutApiNews", { apiNews, id_lista });
    },
    setChannelLayoutBroadcast({ commit }, broadcastWidget) {
      commit("setChannelLayoutBroadcast", broadcastWidget);
    },
    setChannelLayoutId({ commit }, id_canal) {
      commit("setChannelLayoutId", id_canal);
    },
    setChannelLayoutDesign({ commit }, layout) {
      commit("setChannelLayoutDesign", layout);
    },
    mapVideos(_, { videos, state }) {
      return videos.map((video) => {
        return {
          id_archivo_lista: +video.id_file || 0,
          id_archivo_repositorio: +video.id_archivo, // los que vienen del repo
          id_video: +video.id_video, // los que vienen de Videos
          tipo_archivo: "1",
          tiempo_ejecucion: video.tiempo_video,
          total_tiempo: state.channelLayout.tiempo_videos, // tiempo total de playlist
          fecha_activacion: null,
        };
      });
    },
    mapBanners(_, { banners, state }) {
      return banners.map((banner) => {
        return {
          id_archivo_lista: +banner.id_file || 0,
          id_archivo_repositorio: +banner.id_archivo,
          id_video: null,
          tipo_archivo: "2",
          tiempo_ejecucion: moment()
            .startOf("day")
            .add(state.channelLayout.timePerBanner, "seconds")
            .format("HH:mm:ss"),
          total_tiempo: moment()
            .startOf("day")
            .add(
              state.channelLayout.timePerBanner *
                state.channelLayout.banners.length,
              "seconds",
            )
            .format("HH:mm:ss"),
          fecha_activacion: null,
        };
      });
    },
    mapBannersHorizontales(_, { bannersH, state }) {
      return bannersH.map((banner) => {
        return {
          id_archivo_lista: +banner.id_file || 0,
          id_archivo_repositorio: +banner.id_archivo,
          id_video: null,
          tipo_archivo: "5",
          tiempo_ejecucion: moment()
            .startOf("day")
            .add(state.channelLayout.timePerBannerH, "seconds")
            .format("HH:mm:ss"),
          total_tiempo: moment()
            .startOf("day")
            .add(
              state.channelLayout.timePerBannerH *
                state.channelLayout.bannersH.length,
              "seconds",
            )
            .format("HH:mm:ss"),
          fecha_activacion: null,
        };
      });
    },

    mapBannersHorizontalAlto(_, { banners, state }) {
      return banners.map((banner) => {
        return {
          id_archivo_lista: +banner.id_file || 0,
          id_archivo_repositorio: +banner.id_archivo,
          id_video: null,
          tipo_archivo: "14",
          tiempo_ejecucion: moment()
            .startOf("day")
            .add(state.channelLayout.timePerBannersHorizontalAlto, "seconds")
            .format("HH:mm:ss"),
          total_tiempo: moment()
            .startOf("day")
            .add(
              state.channelLayout.timePerBannersHorizontalAlto *
                state.channelLayout.banners.length,
              "seconds",
            )
            .format("HH:mm:ss"),
          fecha_activacion: null,
        };
      });
    },

    mapBannersVerticalAAncho(_, { banners, state }) {
      return banners.map((banner) => {
        return {
          id_archivo_lista: +banner.id_file || 0,
          id_archivo_repositorio: +banner.id_archivo,
          id_video: null,
          tipo_archivo: "8",
          tiempo_ejecucion: moment()
            .startOf("day")
            .add(state.channelLayout.timePerBannerVerticalAAncho, "seconds")
            .format("HH:mm:ss"),
          total_tiempo: moment()
            .startOf("day")
            .add(
              state.channelLayout.timePerBannerVerticalAAncho *
                state.channelLayout.bannersVerticalAAncho.length,
              "seconds",
            )
            .format("HH:mm:ss"),
          fecha_activacion: null,
        };
      });
    },
    mapBannersVerticalBAncho(_, { banners, state }) {
      return banners.map((banner) => {
        return {
          id_archivo_lista: +banner.id_file || 0,
          id_archivo_repositorio: +banner.id_archivo,
          id_video: null,
          tipo_archivo: "9",
          tiempo_ejecucion: moment()
            .startOf("day")
            .add(state.channelLayout.timePerBannerVerticalBAncho, "seconds")
            .format("HH:mm:ss"),
          total_tiempo: moment()
            .startOf("day")
            .add(
              state.channelLayout.timePerBannerVerticalBAncho *
                state.channelLayout.bannersVerticalBAncho.length,
              "seconds",
            )
            .format("HH:mm:ss"),
          fecha_activacion: null,
        };
      });
    },
    mapBannersVerticalCAncho(_, { banners, state }) {
      return banners.map((banner) => {
        return {
          id_archivo_lista: +banner.id_file || 0,
          id_archivo_repositorio: +banner.id_archivo,
          id_video: null,
          tipo_archivo: "10",
          tiempo_ejecucion: moment()
            .startOf("day")
            .add(state.channelLayout.timePerBannerVerticalCAncho, "seconds")
            .format("HH:mm:ss"),
          total_tiempo: moment()
            .startOf("day")
            .add(
              state.channelLayout.timePerBannerVerticalCAncho *
                state.channelLayout.bannersVerticalBAncho.length,
              "seconds",
            )
            .format("HH:mm:ss"),
          fecha_activacion: null,
        };
      });
    },
    mapBannersVerticalAAlto(_, { banners, state }) {
      return banners.map((banner) => {
        return {
          id_archivo_lista: +banner.id_file || 0,
          id_archivo_repositorio: +banner.id_archivo,
          id_video: null,
          tipo_archivo: "11",
          tiempo_ejecucion: moment()
            .startOf("day")
            .add(state.channelLayout.timePerBannerVerticalBAncho, "seconds")
            .format("HH:mm:ss"),
          total_tiempo: moment()
            .startOf("day")
            .add(
              state.channelLayout.timePerBannerVerticalBAncho *
                state.channelLayout.bannersVerticalBAncho.length,
              "seconds",
            )
            .format("HH:mm:ss"),
          fecha_activacion: null,
        };
      });
    },
    mapBannersVerticalBAlto(_, { banners, state }) {
      return banners.map((banner) => {
        return {
          id_archivo_lista: +banner.id_file || 0,
          id_archivo_repositorio: +banner.id_archivo,
          id_video: null,
          tipo_archivo: "12",
          tiempo_ejecucion: moment()
            .startOf("day")
            .add(state.channelLayout.timePerBannerVerticalBAlto, "seconds")
            .format("HH:mm:ss"),
          total_tiempo: moment()
            .startOf("day")
            .add(
              state.channelLayout.timePerBannerVerticalBAlto *
                state.channelLayout.bannersVerticalBAlto.length,
              "seconds",
            )
            .format("HH:mm:ss"),
          fecha_activacion: null,
        };
      });
    },

    mapBannersVerticalCAlto(_, { banners, state }) {
      return banners.map((banner) => {
        return {
          id_archivo_lista: +banner.id_file || 0,
          id_archivo_repositorio: +banner.id_archivo,
          id_video: null,
          tipo_archivo: "13",
          tiempo_ejecucion: moment()
            .startOf("day")
            .add(state.channelLayout.timePerBannerVerticalCAlto, "seconds")
            .format("HH:mm:ss"),
          total_tiempo: moment()
            .startOf("day")
            .add(
              state.channelLayout.timePerBannerVerticalCAlto *
                state.channelLayout.bannersVerticalCAlto.length,
              "seconds",
            )
            .format("HH:mm:ss"),
          fecha_activacion: null,
        };
      });
    },

    mapBannersTresWidgets(_, { banners, state }) {
      return banners.map((banner) => {
        return {
          id_archivo_lista: +banner.id_file || 0,
          id_archivo_repositorio: +banner.id_archivo,
          id_video: null,
          // Tipo 15 asignado para banners_tres_widgets
          tipo_archivo: "15",
          tiempo_ejecucion: moment()
            .startOf("day")
            .add(state.channelLayout.timePer_banners_tres_widgets, "seconds")
            .format("HH:mm:ss"),
          total_tiempo: moment()
            .startOf("day")
            .add(
              state.channelLayout.timePer_banners_tres_widgets *
                state.channelLayout.banners_tres_widgets.length,
              "seconds",
            )
            .format("HH:mm:ss"),
          fecha_activacion: null,
        };
      });
    },

    /**
     * Mapea los widgets para el canal
     * @param {ActionContext} context - El contexto de Vuex
     * @param {Object} param - Parámetros
     * @param {Array} param.widgets - Lista de widgets a mapear
     * @returns {Array} Widgets mapeados
     */
    mapWidgets(_, { widgets }) {
      return widgets.map(
        ({
          id_widget,
          id_objeto,
          tipo_widget,
          tiempo_ejecucion,
          ubicaciones_clima,
          dias_accidente,
          id_rrss,
          cuenta_regresiva,
          id_lista = null,
          condicional_reconocimiento,
          opcion_indicadores = null,
          broadcast = [],
        }) => {
          // opcion_indicadores: {
          //   id_opcion: 2,
          //   array_indicadores: [1,4,32,62,293,272]
          // }
          return {
            condicional_reconocimiento:
              id_objeto == 4 &&
              tipo_widget == "1" &&
              condicional_reconocimiento !== undefined
                ? condicional_reconocimiento
                : null,
            cuenta_regresiva:
              id_objeto == 5
                ? cuenta_regresiva.map(({ titulo, fecha, hora }) => ({
                    titulo,
                    fecha,
                    hora,
                  }))
                : [],
            dias_accidente: id_objeto == 3 ? dias_accidente : null,
            id_lista: id_objeto == 4 ? id_lista : null,
            id_objeto: +id_objeto,
            id_rrss: id_objeto == 4 ? +id_rrss : null,
            id_widget: id_widget ? +id_widget : 0,
            tiempo_ejecucion: moment()
              .startOf("day")
              .add(tiempo_ejecucion, "seconds")
              .format("HH:mm:ss"),
            tipo_widget,
            opcion_indicadores,
            ubicaciones_clima:
              id_objeto == 1
                ? ubicaciones_clima.map((locObj) => ({
                    ubicacion: locObj.ubicacion,
                    latitud: locObj.latitud,
                    longitud: locObj.longitud,
                  }))
                : null,
            broadcast:
              id_objeto == 6
                ? broadcast.map(({ titulo, texto, fecha_inicio, fecha_fin, color_texto, color_background }) => ({
                    titulo,
                    texto,
                    fecha_inicio: fecha_inicio
                      ? fecha_inicio.replace('T', ' ') + (fecha_inicio.length <= 16 ? ':00' : '')
                      : null,
                    fecha_fin: fecha_fin
                      ? fecha_fin.replace('T', ' ') + (fecha_fin.length <= 16 ? ':00' : '')
                      : null,
                    color_texto,
                    color_background,
                  }))
                : [],
          };
        },
      );
    },

    /**
     * Configura el layout del canal
     * @param {ActionContext} context - El contexto de Vuex
     * @param {Object} data_ - Datos del layout
     * @param {String} data_.id_lista - ID de la lista de reproducción
     * @returns {Promise<Object>} El layout configurado
     */
    async setChannelLayout({ dispatch, state }, data_) {
      //FIX TEMPORAL
      state.channelLayout.apiNews = [state.channelLayout.apiNews[0]];

      let widgetsBeforeMap = [1, 2, 3, 11, 13].includes(
        +state.channelLayout.id_layout,
      )
        ? Object.entries(state.channelLayout.widgets)
            .sort((entryA, entryB) => +entryA[0] - +entryB[0])
            .map((entry) => entry[1])
        : [];

      widgetsBeforeMap =
        state.channelLayout.id_layout == 3 ||
        state.channelLayout.id_layout == 11
          ? widgetsBeforeMap.slice(0, 2)
          : widgetsBeforeMap;

      widgetsBeforeMap = [2, 3, 13].includes(+state.channelLayout.id_layout)
        ? widgetsBeforeMap.concat(
            state.channelLayout.apiNews.map((el) => ({
              ...el,
              id_objeto: 4,
              tipo_widget: "2",
              nombre_widget: "RRSS",
              tiempo_ejecucion: "0",
              id_lista: el.id_lista || null,
            })),
          )
        : widgetsBeforeMap;

      if (state.channelLayout.broadcastWidget?.broadcast?.length > 0) {
        widgetsBeforeMap = widgetsBeforeMap.concat([{
          ...state.channelLayout.broadcastWidget,
          id_objeto: 6,
          tipo_widget: "2",
        }]);
      }

      const widgets = await dispatch("mapWidgets", {
        widgets: widgetsBeforeMap,
      });
      const videos = await dispatch("mapVideos", {
        videos: state.channelLayout.videos,
        state,
      });
      const banners = await dispatch("mapBanners", {
        banners:
          state.channelLayout.id_layout == 3 ? [] : state.channelLayout.banners,
        state,
      });
      const banners_horizontales = await dispatch("mapBannersHorizontales", {
        bannersH:
          state.channelLayout.id_layout == 4
            ? state.channelLayout.bannersH
            : [],
        state,
      });
      const banners_horizontales_alto = await dispatch(
        "mapBannersHorizontalAlto",
        {
          banners:
            state.channelLayout.id_layout == 4 ||
            state.channelLayout.id_layout == 5
              ? state.channelLayout.bannersHorizontalAlto
              : [],
          state,
        },
      );
      //bannersVerticalAAncho
      const banners_lv_ancho_a = await dispatch("mapBannersVerticalAAncho", {
        banners:
          state.channelLayout.id_layout == 8 ||
          state.channelLayout.id_layout == 9 ||
          state.channelLayout.id_layout == 10
            ? state.channelLayout.bannersVerticalAAncho
            : [],
        state,
      });
      // bannersVerticalBAncho
      const banners_lv_ancho_b = await dispatch("mapBannersVerticalBAncho", {
        banners:
          state.channelLayout.id_layout == 9
            ? state.channelLayout.bannersVerticalBAncho
            : [],
        state,
      });
      const banners_lv_ancho_c = await dispatch("mapBannersVerticalCAncho", {
        banners:
          state.channelLayout.id_layout == 10
            ? state.channelLayout.bannersVerticalCAncho
            : [],
        state,
      });
      const banners_lv_alto_a = await dispatch("mapBannersVerticalAAlto", {
        banners:
          state.channelLayout.id_layout == 11
            ? state.channelLayout.bannersVerticalAAlto
            : [],
        state,
      });
      const banners_lv_alto_b = await dispatch("mapBannersVerticalBAlto", {
        banners:
          state.channelLayout.id_layout == 12
            ? state.channelLayout.bannersVerticalBAlto
            : [],
        state,
      });
      const banners_lv_alto_c = await dispatch("mapBannersVerticalCAlto", {
        banners:
          state.channelLayout.id_layout == 12
            ? state.channelLayout.bannersVerticalCAlto
            : [],
        state,
      });
      const banners_tres_widgets = await dispatch("mapBannersTresWidgets", {
        banners:
          state.channelLayout.id_layout == 13
            ? state.channelLayout.banners_tres_widgets
            : [],
        state,
      });

      // --- LOGO ---

      const isEditing = Boolean(data_.id_lista);
      const newLogoSrc = state.channelLayout.logo?.src || "";
      const existingRemoteLogo = state.channelLayout.url_logo || "";

      let logo;
      if (!state.channelLayout.logoActive) {
        // Desactivado por el usuario
        logo = null;
      } else if (newLogoSrc) {
        // Nuevo logo cargado en esta sesión
        logo = newLogoSrc;
      } else if (isEditing && existingRemoteLogo && !state.logoDeleted) {
        // Mantener el logo existente del servidor al editar sin cambios
        logo = existingRemoteLogo;
      } else if (state.logoDeleted) {
        // Se eliminó el logo (mantener semántica previa de usar placeholder)
        logo = DEFAULT_LOGO_URL;
      } else if (!isEditing) {
        // Creación y no se definió logo
        logo = existingRemoteLogo || DEFAULT_LOGO_URL;
      } else {
        // Fallback seguro
        logo = existingRemoteLogo || DEFAULT_LOGO_URL;
      }

      // Determinar formato. Solo cuando hay logo activo y se subió uno nuevo con formato.
      let formato_logo = null;
      if (state.channelLayout.logoActive && state.channelLayout.logo?.format) {
        formato_logo = `image/${state.channelLayout.logo.format}`;
      } else if (!state.channelLayout.logoActive) {
        formato_logo = `image/null`; // logo desactivado
      }

      const payload = {
        id_canal: +state.channelLayout.id_canal,
        lista: {
          id_lista: +data_.id_lista ?? undefined,
          id_layout: +state.channelLayout.id_layout,
          logo,
          id_tema: state.channelLayout.id_tema,
          formato_logo: formato_logo,
          color: state.channelLayout.color,
          color_tipografia: state.channelLayout.color_tipografia || "#ffffff",
          videos,
          banners,
          banners_horizontales,
          banners_horizontales_alto,
          banners_lv_ancho_a,
          banners_lv_ancho_b,
          banners_lv_ancho_c,
          banners_lv_alto_a,
          banners_lv_alto_b,
          banners_lv_alto_c,
          banners_tres_widgets,
          widgets,
        },
      };
      /* CanalListaObjectNewUpdated
        id_lista Int
        id_layout Int
        id_tema Int
        logo String
        formato_logo String
        color String
        color_tipografia String
        videos [VideosBannersObjects]
        banners [VideosBannersObjects]
        banners_horizontales [VideosBannersObjects]
        banners_horizontales_alto [VideosBannersObjects]
        banners_lv_alto_a [VideosBannersObjects]
        banners_lv_alto_b [VideosBannersObjects]
        banners_lv_alto_c [VideosBannersObjects]
        banners_lv_ancho_a [VideosBannersObjects]
        banners_lv_ancho_b [VideosBannersObjects]
        banners_lv_ancho_c [VideosBannersObjects]
        widgets [WidgetsObjectsNew]
      */
      const mutation = data_.id_lista
        ? EDIT_CHANNEL_LAYOUT
        : SAVE_CHANNEL_LAYOUT;
      const params = {
        mutation,
        variables: payload,
      };

      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading)
          response = data_.id_lista
            ? res.data.UpdateListaReproduccion
            : res.data.SaveListaReproduccion;

        //response = await exMut(mutation, payload);
      } catch (e) {
        console.error(e);
      }

      return response;
    },

    /**
     * Obtiene la información de un canal
     * @param {ActionContext} context - El contexto de Vuex
     * @param {Object} data_ - Filtros para obtener el canal
     * @returns {Promise<Object>} Información del canal
     */
    async getCanal({ commit }, data_) {
      let response = [];
      try {
        response = await exQue(GET_ONE_CANAL, data_, true);
        commit("getCanal", response);
      } catch (e) {
        console.error("Error getCanal:");
        console.error(e);
        if (e?.networkError?.result?.errors) {
          console.error(e.networkError.result.errors);
        }
        response = null;
      }
      return response;
    },

    async getWidgets() {
      let response = null;
      try {
        response = await exQue(GET_ALL_WIDGETS, {}, true);
      } catch (e) {
        console.error(e);
      }

      return response;
    },

    async getNoticiasOpciones() {
      let response = null;
      try {
        response = await exQue(GET_NOTICIAS_OPCIONES, {}, true);
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    /**
     * Sube un archivo mediante suscripción
     * @param {ActionContext} context - El contexto de Vuex
     * @param {Object} data_ - Datos del archivo
     * @param {String} data_.id_empresa - ID de la empresa
     * @param {String} data_.id_usuario - ID del usuario
     * @param {String} data_.descripcion - Descripción del archivo
     * @param {String} data_.tipo_archivo - Tipo de archivo
     * @param {Object} data_.file - Archivo a subir
     * @returns {Observable} Suscripción de apollo
     */
    uploadFileSubscription(_, data_) {
      const {
        id_empresa,
        id_usuario,
        tipo_archivo,
        file,
        descripcion,
        inputUri = null,
        filenameInputUri = null,
        fileName = null,
        imagen_b64 = null,
        formato_imagen_b64 = null,
      } = data_;
      const duration = data_.duration
        ? new Date(data_.duration * 1000).toISOString().slice(11, 19)
        : new Date(file.duration * 1000).toISOString().slice(11, 19);
      const payload = {
        id_empresa,
        id_usuario,
        descripcion_archivo: descripcion || "",
        tiempo: String(duration),
        tipo_archivo: Number(tipo_archivo),
        nombre_archivo: file.name || "",
        archivo_b64: file.src || "",
        formato_b64: file.type || "",
        inputUri,
        filenameInputUri,
        fileName,
        imagen_b64,
        formato_imagen_b64,
      };

      const params = {
        query: SAVE_FILE_REPO,
        variables: payload,
      };
      return apolloClient.subscribe(params);
    },

    async deleteFileRepositorio({ commit }, { id_archivo, type }) {
      let res = null;
      try {
        res = await exMut(DELETE_FILE_REPOSITORIO, { id_archivo });
        if (res) {
          commit("deleteRepoFile", { deleted: res, type });
        }
      } catch (error) {
        console.error("Error en deleteFileRepositorio:", error);
      }
      return res;
    },

    /**
     * Obtiene los archivos del repositorio
     * @param {ActionContext} context - El contexto de Vuex
     * @param {Object} data_ - Filtros de búsqueda
     * @returns {Promise<Array>} Lista de archivos
     */
    async getRepoFiles(_, data_) {
      let response = null;
      try {
        response = await exQue(GET_PAGINAS_FILES_REPOSITORIO, data_);
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    /**
     * Obtiene la paginación de archivos
     * @param {ActionContext} context - El contexto de Vuex
     * @param {Object} data_ - Filtros de paginación
     * @returns {Promise<Object>} Datos de paginación
     */
    async getFilesPagination({ commit }, { data, id_detalle = null }) {
      let response = null;
      try {
        response = await exQue(GET_TOTAL_FILES_REPOSITORIO, data, true);
        commit("setPagination", {
          pagination: response,
          payload: data,
          id_detalle,
        });
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async getAllRepoFiles({ dispatch, commit }, { data, id_detalle = null }) {
      Object.assign(data, {
        nombreArchivo: "",
      });
      const filesIds = await dispatch("getFilesPagination", { data: data });

      let allFiles = null;
      if (filesIds !== null) {
        let repoFilesIds = filesIds.reduce(
          (ids, page) => ids.concat(page.ids),
          [],
        );
        allFiles = await dispatch("getRepoFiles", {
          idEmpresa: data.idEmpresa,
          idArchivo: repoFilesIds,
        });
        
        commit("setAllRepoFiles", { fileObjArr: allFiles, id_detalle });
      }
      return allFiles;
    },
  },
};
